import { Button, Checkbox, Col, Form, Modal, Row, Spin, Input, InputNumber } from 'antd';
import { useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import BreadCrumbs from '../../../../common/components/Breadcrumbs';
import { validateMessages } from '../../../../common/constants/common';
import { Page } from '../../../../common/constants/pageAction';
import { getObjectForUpdateMultiple } from '../../../../common/helperFunction';
import { IConfigSoftwareEdition } from '../../../../services/master/configSoftwareEdition/configSoftwareEdition.model';
import { useAppSelector, useAppDispatch } from '../../../../store/app.hooks';
import { updateMultiple } from '../../../../store/common/common.action';
import {
  clearMultipleUpdateMessages,
  commonSelector,
} from '../../../../store/common/common.reducer';
import {
  getConfigSoftwareEditionById,
  saveConfigSoftwareEdition,
} from '../../../../store/master/configSoftwareEdition/configSoftwareEdition.action';
import {
  clearConfigSoftwareEditionGetById,
  clearConfigSoftwareEditionMessages,
  configSoftwareEditionSelector,
} from '../../../../store/master/configSoftwareEdition/configSoftwareEdition.reducer';
import { IAddConfigSoftwareEditionProps } from './addConfigSoftwareEdition.model';
import _ from 'lodash';

const AddConfigSoftwareEditionModal: React.FC<IAddConfigSoftwareEditionProps> = (props) => {
  const configSoftwareEdition = useAppSelector(configSoftwareEditionSelector);
  const common = useAppSelector(commonSelector);
  const dispatch = useAppDispatch();
  const { id, showModal, handleModalClose, refreshDataTable, isMultiple, valuesForSelection } =
    props;

  const isNew: boolean = id || isMultiple ? false : true;
  const title = useMemo(() => {
    return (
      <>
        {isNew ? 'Add ' : 'Edit '} <BreadCrumbs pageName={Page.ConfigSoftwareEdition} level={1} />
      </>
    );
  }, [isNew]);
  const submitButtonText = useMemo(() => {
    return isNew ? 'Save' : 'Update';
  }, [isNew]);

  const [form] = Form.useForm();

  let initialValues: IConfigSoftwareEdition = {
    edition: '',
    edition_index: null,
  };

  const onFinish = (values: any) => {
    const inputValues: IConfigSoftwareEdition = {
      ...values,
      id: id ? +id : null,
    };
    if (!isMultiple) {
      dispatch(saveConfigSoftwareEdition(inputValues));
    } else {
      const result = getObjectForUpdateMultiple(
        valuesForSelection,
        inputValues,
        configSoftwareEdition.search.tableName
      );
      if (result) {
        dispatch(updateMultiple(result));
      }
    }
  };

  const fillValuesOnEdit = async (data: IConfigSoftwareEdition) => {
    if (data) {
      initialValues = {
        edition: data.edition,
        edition_index: _.isNull(data.edition_index) ? null : data.edition_index,
      };
      form.setFieldsValue(initialValues);
    }
  };

  useEffect(() => {
    if (configSoftwareEdition.save.messages.length > 0) {
      if (configSoftwareEdition.save.hasErrors) {
        toast.error(configSoftwareEdition.save.messages.join(' '));
      } else {
        toast.success(configSoftwareEdition.save.messages.join(' '));
        handleModalClose();
        refreshDataTable();
      }
      dispatch(clearConfigSoftwareEditionMessages());
    }
  }, [configSoftwareEdition.save.messages]);

  useEffect(() => {
    if (common.save.messages.length > 0) {
      if (common.save.hasErrors) {
        toast.error(common.save.messages.join(' '));
      } else {
        toast.warn(common.save.messages.join(' '));
        handleModalClose();
        refreshDataTable();
      }
      dispatch(clearMultipleUpdateMessages());
    }
  }, [common.save.messages]);

  useEffect(() => {
    if (+id > 0 && configSoftwareEdition.getById.data) {
      const data = configSoftwareEdition.getById.data;
      fillValuesOnEdit(data);
    }
  }, [configSoftwareEdition.getById.data]);

  useEffect(() => {
    if (+id > 0) {
      dispatch(getConfigSoftwareEditionById(+id));
    }
    return () => {
      dispatch(clearConfigSoftwareEditionGetById());
    };
  }, [dispatch]);

  return (
    <>
      <Modal
        wrapClassName="custom-modal"
        title={title}
        centered
        visible={showModal}
        onCancel={handleModalClose}
        footer={false}
      >
        {configSoftwareEdition.getById.loading ? (
          <div className="spin-loader">
            <Spin spinning={configSoftwareEdition.getById.loading} />
          </div>
        ) : (
          <Form
            form={form}
            name="configSoftwareEdition"
            initialValues={initialValues}
            onFinish={onFinish}
            validateMessages={validateMessages}
          >
            <Row gutter={[30, 15]} className="form-label-hide">
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'edition']} valuePropName="checked" noStyle>
                      <Checkbox>Edition</Checkbox>
                    </Form.Item>
                  ) : (
                    'Edition'
                  )}
                  <Form.Item
                    name="edition"
                    label="Edition"
                    className="m-0"
                    rules={[{ required: !isMultiple, max: 255 }]}
                  >
                    <Input className="form-control" />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'edition_index']} valuePropName="checked" noStyle>
                      <Checkbox>Edition Index</Checkbox>
                    </Form.Item>
                  ) : (
                    'Edition Index'
                  )}
                  <Form.Item
                    name="edition_index"
                    label="Edition Index"
                    className="m-0"
                    rules={[{ type: 'integer' }]}
                  >
                    <InputNumber className="form-control w-100" />
                  </Form.Item>
                </div>
              </Col>
            </Row>
            <div className="btns-block modal-footer">
              <Button
                key="submit"
                type="primary"
                htmlType="submit"
                loading={configSoftwareEdition.save.loading || common.save.loading}
              >
                {submitButtonText}
              </Button>
              <Button key="back" onClick={handleModalClose}>
                Cancel
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    </>
  );
};
export default AddConfigSoftwareEditionModal;
